import { BaseLocator } from "./base.locator";
import { CategoryIdLocatorComponent } from "./categoryid.locator-component";

export class RecordHistoryListLocator extends BaseLocator {
  recordType: CategoryIdLocatorComponent;
  recordLevel: CategoryIdLocatorComponent;
  recordArea: CategoryIdLocatorComponent;

  constructor() {
    super("recordHistoryList");
    this.addComponentByType("catid", "recordType");
    this.addComponentByType("catid", "recordLevel");
    this.addComponentByType("catid", "recordArea");
  }
}
